import { z } from 'zod';

export const moneySchema = z.string().transform(Number.parseFloat);
